import React, { useState } from 'react';
import './contactus.css';
import './contactus.css';
import { db } from '../FirebaseComp/firebase'; // Adjust path as needed
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';




function ContactUs() {
   const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Add document to Firestore
      await addDoc(collection(db, 'contactus'), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
        createdAt: serverTimestamp()
      });
      
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setErrors({});
      
      // Reset submission status after 5 seconds
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Error saving contact form:', error);
      alert('There was an error submitting your form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contact Southern Rehab Care</h1>
        <p>We're here to help and answer any questions you might have.</p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>Our Location</h3>
            <p>Hirimbura Rd, Galle 80000, Sri Lanka</p>
          </div>

          <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-phone-alt"></i>
            </div>
            <h3>Call Us</h3>
            <p>077 743 9610</p>
            <p>071 447 6402</p>
          </div>

          <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Email Us</h3>
            <p>info@southernrehabcare.lk</p>
          </div>

          <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-clock"></i>
            </div>
            <h3>Working Hours</h3>
            <p>Monday - Friday: 4:00 PM - 8:00 PM</p>
            <p>Saturday - Sunday: 9:00 AM - 4:00 PM</p>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>Message Sent!</h2>
          {submitted ? (
            <div className="success-message">
              <i className="fas fa-check-circle"></i>
              <p>Thank you for contacting us! We'll get back to you soon.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name*</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={errors.name ? 'error' : ''}
                />
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? 'error' : ''}
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

<div className="form-group">
  <label htmlFor="subject">Subject</label>
  <select
    id="subject"
    name="subject"
    value={formData.subject}
    onChange={handleChange}
  >
    <option value="">Select a subject</option>
    <option value="upper_extremity">Upper Extremity Prosthetics & Orthotics</option>
    <option value="lower_extremity">Lower Extremity Prosthetics & Orthotics</option>
    <option value="rehab_mobility">Reha Mobility Solutions</option>
    <option value="children_orthopedics">Orthopedics for Children</option>
    <option value="other">Other</option>
  </select>
</div>

              <div className="form-group">
                <label htmlFor="message">Your Message*</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  className={errors.message ? 'error' : ''}
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          )}
        </div>
      </div>

      <div className="contact-map">
        <iframe
          title="Southern Rehab Care - Location"
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.474356088331!2d80.2199589!3d6.0665819999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae171254a7eef49%3A0x635255ca4318ee2c!2sSouthern%20REHAB%20care!5e0!3m2!1sen!2slk!4v1773508059255!5m2!1sen!2slk"          referrerPolicy="no-referrer-when-downgrade"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactUs;